<div class="paging">
    <div class="paging__seperator"></div>
    <a
        class="btn btn--sm paging__button"
        [class.disabled]="selectedPageNumber === 1"
        [href]="location.pathname + '?p=' + (selectedPageNumber - 1)"
        (click)="selectedPageNumber === 1 ? $event.preventDefault() : null"
        [attr.rel]="selectedPageNumber === 1 ? 'nofollow' : null"
        title="Vorige pagina"
    >
        Vorige
        <span class="screen-reader-only">pagina</span>
    </a>
    <a
        *ngFor="let pageNumber of shownPageNumbers"
        class="btn btn--sm paging__button"
        [class.disabled]="selectedPageNumber === pageNumber"
        [href]="location.pathname + '?p=' + pageNumber"
        (click)="selectedPageNumber === pageNumber ? $event.preventDefault() : null"
        [attr.rel]="selectedPageNumber === pageNumber ? 'nofollow' : null"
        [title]="'Ga naar pagina ' + pageNumber"
    >
        <span class="screen-reader-only">Ga naar pagina</span>
        {{ pageNumber }}
    </a>
    <a
        class="btn btn--sm paging__button"
        [class.disabled]="selectedPageNumber >= totalPages"
        [href]="location.pathname + '?p=' + (selectedPageNumber + 1)"
        (click)="selectedPageNumber >= totalPages ? $event.preventDefault() : null"
        [attr.rel]="selectedPageNumber >= totalPages ? 'nofollow' : null"
        title="Volgende pagina"
    >
        Volgende
        <span class="screen-reader-only">pagina</span>
    </a>
</div>
